import React from 'react';
import { View, Text, StyleSheet, Platform, Alert, TouchableOpacity } from 'react-native';
import CS from '../../constants/Styles';
import { Button, BackgroundGradient, Loader } from '../../components';
import { FontAwesome5 } from '@expo/vector-icons';
import Money from './Money';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useHeaderHeight } from '@react-navigation/elements';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { useLinkTo } from '@react-navigation/native';

const MoneyScreen = function MoneyScreen({ ...props }) {
  const [loading, setLoading] = React.useState(false);

  const headerHeight = useHeaderHeight();
  const insets = useSafeAreaInsets();
  const linkTo = useLinkTo();

  // const textInputs = {
  //   transitNo: React.useRef(null),
  //   institutionNo: React.useRef(null),
  //   accountNo: React.useRef(null),
  // };

  React.useEffect(() => {
    checkSignUpProgress();
  }, []);

  const checkSignUpProgress = (route) => {
    if (!props.signUpProgress.EmergencyContacts) {
      linkTo('/login');
    }
  }

  const checkMoney = async () => {
    console.log('checkMoney');
    if (!props.moneyMethod || !['direct deposit', 'mail', 'e-transfer'].includes(props.moneyMethod)) {
      Alert.alert('Invalid', 'Please select a method to receive your money.');
      return;
    }
    // props.completeStep('Money');
    try{
      setLoading(true);
      let signUpResult = await props.confirmDetails();
      console.log('checkMoney signUpResult', signUpResult);
      setLoading(false);
    }catch(err){
      console.log('checkMoney err', err);
      Alert.alert('Error', 'Something went wrong, please try again later');
      setLoading(false);
    }
  };
  // const clearDirectDepositValues = () => {
  //   props.setTransitNo(null);
  //   props.setInstitutionNo(null);
  //   props.setAccountNo(null);
  // };
  // const selectMailACheque = () => {
  //   console.log('selectMailACheque');
  //   clearDirectDepositValues();
  //   props.setMoneyMethod('mail');
  // };
  // const selectETransfer = () => {
  //   clearDirectDepositValues();
  //   props.setMoneyMethod('e-transfer')
  // };
  // const changeTransitNo = (text) => {
  //   props.setTransitNo(text);
  //   if(text.length === 5){
  //     textInputs.institutionNo.current.focus()
  //   }
  // }
  // const changeInstitutionNo = (text) => {
  //   props.setInstitutionNo(text);
  //   if (text.length === 3) {
  //     textInputs.accountNo.current.focus()
  //   }
  // }

  const goBack = () => {
    if (props.navigation.canGoBack()) {
      props.navigation.goBack();
    } else {
      linkTo('/signup/emergencycontacts');
    }
  }

  return (
    <View style={CS.container}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <KeyboardAwareScrollView keyboardShouldPersistTaps='handled' extraHeight={headerHeight + 20} contentContainerStyle={[styles.innerContainer, { paddingTop: insets.top, paddingBottom: insets.bottom }]} style={styles.container}>
        <TouchableOpacity onPress={goBack} style={{ marginTop: 10, marginBottom: 20, justifyContent: 'center' }}>
          <FontAwesome5 name="arrow-left" size={24} color="white" style={{ position: 'absolute' }} />
          <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, { marginVertical: 0 }]}>Receiving Money</Text>
        </TouchableOpacity>
        <Text style={[CS.lightBlueText, CS.smallText, styles.paragraph]}>Select how you want to receive your payments</Text>
        <View style={{ marginBottom: 10 }}>
          <Money {...props} type='New' />
        </View>
        {/* <View style={{ marginTop: 'auto' }}> */}
        <View style={{ marginTop: Platform.OS === 'web' ? 0 : 'auto' }}>
          <Button text='Sign Up' onPress={() => checkMoney} />
        </View>
      </KeyboardAwareScrollView>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    marginVertical: 10,
  },
  innerContainer: {
    width: '100%',
    // backgroundColor: 'blue',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    flexGrow: 1,
    alignSelf: 'center',
  },
  paragraph: {
    marginBottom: 20,
  },
});

export default React.memo(MoneyScreen);